import { appUrl } from 'utils/wrappers';

import Base from 'app/models/base';

export const TRACKING_PAGE_THEMES = {
  THEME1: 'theme1',
  THEME2: 'theme2',
};

export default Base.extend({
  url() {
    return appUrl(`users/${this.user.id}/brand`);
  },

  initialize({ user }) {
    this.user = user;
  },

  isNew() {
    return !this.has('object'); // Makes model.save perform a PUT vs POST. Brands don't have IDs
  },

  toJSON(options = {}) {
    const {
      name, background_color, color, logo, logo_href, ad, ad_href, theme,
    } = this.attributes;
    const json = {
      name, background_color, color, logo_href, ad_href, theme,
    };
    if (options.includeHrefs || (logo && logo.startsWith('data:image/'))) json.logo = logo;
    if (options.includeHrefs || (ad && ad.startsWith('data:image/'))) json.ad = ad;
    return json;
  },

  setToDefaults(options) {
    this.update({
      ad: null,
      ad_href: null,
      background_color: null,
      color: null,
      name: null,
      logo: null,
      logo_href: null,
      theme: null,
    }, options);
  },
});



// WEBPACK FOOTER //
// ./app/models/brand.js